import {Text, Typography} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import React from 'react'

import {Button} from '../../button'
import {DOWNLOAD_YANGO_APP} from '../../promo'
import {classes} from './YangoPromoButton.styles'

type Props = {
  onClick: JSX.IntrinsicElements['a']['onClick']
}

const YangoPromoButton: React.FC<Props> = ({onClick}) => {
  const t = useI18n()

  return (
    <Button
      className={classes.root}
      href={DOWNLOAD_YANGO_APP}
      onClick={onClick}
      target="_blank"
      variant="action"
      fullWidth
    >
      <Text>
        <Typography color="invert" thickness="medium" variant="body2">
          {t('yango_route_postcard_download_app', 'Скачать Yango')}
        </Typography>
        <Typography color="invert" variant="caption1">
          {t('route_postcard_download_text')}
        </Typography>
      </Text>
    </Button>
  )
}

export default YangoPromoButton
